import { Logo } from "./Logo";
import { scrollToId } from "./Reveal";

const LINKS = [["approach", "Approach"], ["services", "Services"], ["framework", "Care Framework"], ["vision", "Vision"], ["book", "Book"], ["contact", "Contact"]];

export const Footer = () => (
  <footer data-testid="main-footer-container" className="bg-[#0B2B26] text-[#F6F4EE] pt-20 pb-10 overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm text-[#C7D8D2] leading-relaxed">Specialised health consultations, clinical care management and personalised lifestyle solutions — from Bhopal.</p>
        </div>
        <nav className="md:col-span-4 grid grid-cols-2 gap-3">
          {LINKS.map(([id, l]) => (
            <button key={id} data-testid={`footer-${id}-link`} onClick={() => scrollToId(id)} className="text-left text-[#DDE8E4] hover:text-[#E9A184] transition-colors">{l}</button>
          ))}
        </nav>
        <p className="md:col-span-3 text-sm text-[#B9CFC9] leading-relaxed">Information on this site is general and does not replace an in-person medical consultation.</p>
      </div>
      <p className="mt-20 font-display tracking-[-0.04em] leading-[0.85] text-[22vw] lg:text-[17rem] text-[#F6F4EE]/[0.08] select-none" aria-hidden="true">Welcon</p>
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#B9CFC9] border-t border-white/10 pt-6">
        <p data-testid="footer-copyright-text">© {new Date().getFullYear()} Welcon Health Consultations LLP. All rights reserved.</p>
        <p>Bhopal, Madhya Pradesh, India</p>
      </div>
    </div>
  </footer>
);
